module.exports = __webpack_public_path__ + "static/bg_button_mobile-4fbdbe9e2adfbb0a3c6dffc9e0cba17f.jpg";